import React from "react";
import {Button} from "antd";
import Table from "antd/es/table";
import {Route, Switch} from "react-router-dom";
import CreateForm from "./create";

import {fetchResource, fetchResourceSuccess, updateResource,} from "../../appRedux/actions/NotificationSetting";
import {connect} from "react-redux";
import {faviconDynamicFunction} from "../../util/methods";

class NotificationSetting extends React.Component {

  updateResource = (values, servicename) => {
    this.props.updateResource(values, servicename);
  };

  edit = (service) => {
    const {match} = this.props;
    this.props.fetchResource(service);
    this.props.history.push(`${match.url}/edit/${service}`);
  };

  render() {
    const {match, smtpData, authUser, loading} = this.props;
    faviconDynamicFunction(authUser);

    const columnsForIndex = [
      {title: 'Service', dataIndex: 'service', key: 'service'},
      {
        title: 'Action',
        dataIndex: '',
        key: 'x',
        render: (text, record) => {
          if(record.service === 'SMTP') {
            return record.service === 'SMTP' ? <Button onClick={() => this.edit(record.service)}
                                                       type="primary">EDIT</Button> :
              <Button type="primary">EDIT</Button>
          }
          // else if (record.service === 'SMS') {
          //   return record.service === 'SMS' ? <Button onClick={() => {
          //   }} type="primary">EDIT</Button> : <Button type="primary" disabled={true}>EDIT</Button>
          // } else if (record.service === 'SLACK') {
          //   return record.service === 'SLACK' ? <Button onClick={() => {
          //   }} type="primary">EDIT</Button> : <Button type="primary" disabled={true}>EDIT</Button>
          // }
        }
      },
    ];
    const dataForIndex = [
      {
        key: 1,
        service: 'SMTP',
      },
      // {
      //   key: 2,
      //   service: 'SMS',
      // },
      // {
      //   key: 3,
      //   service: 'SLACK',
      // },

    ];
    return (
      <div>
        <Switch>
          <Route exact path={`${match.url}`}
                 render={(props) => <div>
                   <h1 style={{marginBottom: "30px"}}>Notification Settings</h1>
                   <Table
                     style={{fontSize: '20px'}}
                     columns={columnsForIndex}
                     expandable={{
                       expandedRowRender: record => <p style={{margin: 0}}>{record.description}</p>,
                       rowExpandable: record => record.name !== 'Not Expandable',
                     }}
                     dataSource={dataForIndex}
                   />
                 </div>
                 }
          />
          <Route exact path={`${match.url}/edit/SMTP`}
                 render={(props) => <CreateForm data={smtpData}
                                                title={'UPDATE'}
                                                resource={'SMTP Configuration'}
                                                service={'SMTP'}
                                                onSubmit={this.updateResource}
                                                loading={loading}
                                                {...props}
                 />
                 }/>
        </Switch>
      </div>
    )
  }
}

const mapStateToProps = ({auth, notificationSetting, commonData}) => {
  return {
    authUser: auth.authUser,
    loading: commonData.loading,
    smtpData: notificationSetting.data,
    message: commonData.message,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    fetchResourceSuccess,
    fetchResource,
    updateResource,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(NotificationSetting);
